import {
    Button,
    Dialog,
    DialogContent,
    DialogTitle,
    DialogActions,
    Grid,
    Typography,
    useTheme,
    ThemeProvider,
    RadioGroup,
    Radio,
    FormControlLabel
} from "@mui/material";
import React from "react";
import { useAtom } from "jotai";
import { recurringRecheduleChoiceAtom } from "../atoms/providerReschedule";
import { DialogTheme } from "../styles/DialogTheme";

function ProviderRecurringRescheduleChoiceModal(props) {
    const [recurringRescheduleChoice, setRecurringRecheduleChoice] = useAtom(
        recurringRecheduleChoiceAtom
    );
    const theme = useTheme();

    return (
        <>
            <ThemeProvider theme={DialogTheme(theme)}>
                <Dialog
                    open={props.showGetRecurringBookingRescheduleChoiceModal}
                    onClose={props.onClose}
                    maxWidth="sm"
                >
                    <DialogTitle>
                        <Typography variant="smallTitle">
                            Reschedule booking
                        </Typography>
                    </DialogTitle>
                    <DialogContent>
                        <Grid
                            container
                            gap="16px"
                            sx={{
                                overflow: "hidden",
                                position: "relative",
                                top: "-3px"
                            }}
                        >
                            <Typography>
                                This booking is part of a recurring set – how do
                                you wish to continue?
                            </Typography>
                            <RadioGroup
                                aria-labelledby="recurring-reschedule-choice"
                                defaultValue={recurringRescheduleChoice}
                                name="recurring-reschedule-choice-radio-buttons-group"
                                onChange={(e) => {
                                    setRecurringRecheduleChoice(e.target.value);
                                }}
                            >
                                <Grid item>
                                    <FormControlLabel
                                        value="SELECTED"
                                        control={
                                            <Radio
                                                disableRipple
                                                sx={{
                                                    padding: "0px 10px",
                                                    "& .MuiSvgIcon-root": {
                                                        width: "1.1rem",
                                                        height: "1.1rem"
                                                    }
                                                }}
                                            />
                                        }
                                        label="Reschedule only this session"
                                    />
                                </Grid>
                                <Grid item>
                                    <FormControlLabel
                                        value="ALL_FUTURE"
                                        control={
                                            <Radio
                                                disableRipple
                                                sx={{
                                                    padding: "0px 10px",
                                                    "& .MuiSvgIcon-root": {
                                                        width: "1.1rem",
                                                        height: "1.1rem"
                                                    }
                                                }}
                                            />
                                        }
                                        label={
                                            <Typography variant="body1">
                                                Reschedule{" "}
                                                <Typography
                                                    component={"span"}
                                                    sx={{
                                                        textDecoration:
                                                            "underline"
                                                    }}
                                                >
                                                    all
                                                </Typography>{" "}
                                                future sessions
                                            </Typography>
                                        }
                                    />
                                </Grid>
                            </RadioGroup>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Grid display={"flex"} gap={"18px"}>
                            <Button
                                variant="outlined"
                                onClick={() => {
                                    setRecurringRecheduleChoice("SELECTED");
                                    props.onClose();
                                }}
                            >
                                Cancel
                            </Button>
                            <Button
                                variant="contained"
                                onClick={props.onContinue}
                            >
                                Continue
                            </Button>
                        </Grid>
                    </DialogActions>
                </Dialog>
            </ThemeProvider>
        </>
    );
}
export default ProviderRecurringRescheduleChoiceModal;
